import { render, staticRenderFns } from "./build0.vue?vue&type=template&id=35c8a112&scoped=true&"
import script from "./build0.vue?vue&type=script&lang=js&"
export * from "./build0.vue?vue&type=script&lang=js&"
import style0 from "./build0.vue?vue&type=style&index=0&id=35c8a112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8a112",
  null
  
)

export default component.exports